import { ToggleButtonGroup as BaseToggleButtonGroup, ToggleButton } from '@mui/material';
import type { ToggleButtonGroupProps } from '@mui/material';

const ToggleButtonGroup = ({
  options,
  ...props
}: ToggleButtonGroupProps & { options: { label: string; value: string }[] }) => {
  return (
    <BaseToggleButtonGroup
      value={options[0].value}
      size="small"
      color="primary"
      sx={{
        p: '4px',
        border: 0,
        backgroundColor: 'neutral.100',
        '& button': {
          border: 0,
          fontSize: 12,
          fontWeight: 700,
          lineHeight: '10px',
          color: 'text.secondary',
          '&.Mui-selected': {
            p: '3px 10px',
            color: 'white',
            backgroundColor: 'primary.main',
            borderTopLeftRadius: '6px !important',
            borderTopRightRadius: '6px !important',
            borderBottomLeftRadius: '6px !important',
            borderBottomRightRadius: '6px !important',
            '&:hover': {
              backgroundColor: '#2D3743',
            },
          },
        },
      }}
      {...props}
    >
      {options.map(({ label, value }) => (
        <ToggleButton key={value} value={value}>
          {label}
        </ToggleButton>
      ))}
    </BaseToggleButtonGroup>
  );
};

export default ToggleButtonGroup;
